import React, { SyntheticEvent } from 'react';
import cx from 'classnames';

import './radio-button.css';

interface Props {
    addClasses?: string;
    disabled?: boolean;
    groupDirection?: RadioGroupDirection;
    isChecked: boolean;
    /**
     * When true, the `sr-only` class is applied to the label so that it is shown for screen readers
     * only. When using `labelSrOnly={true}`, you should most likely include a visible label
     * elsewhere in the DOM.
     */
    labelSrOnly?: boolean;
    option: RadioButtonOption;
    handleChange(radioButtonUpdate: RadioButtonUpdate): void;
}

/**
 * An <input> element whose `checked` state is controlled by its parent component.
 */
export const RadioButton = ({
    disabled = false,
    groupDirection = 'vertical',
    isChecked,
    labelSrOnly = false,
    option,
    handleChange,
}: Props): JSX.Element => {
    const { inputId, label, value } = option;

    return (
        <div className="mx-2">
            <input
                id={inputId}
                disabled={disabled}
                type="radio"
                onChange={(e: SyntheticEvent): void => {
                    const target = e.target as HTMLInputElement;

                    if (target.checked) {
                        handleChange({ checked: true, value });
                    } else {
                        handleChange({ checked: false, value });
                    }
                }}
                checked={isChecked}
            />
            <label
                htmlFor={inputId}
                className={cx('align-middle', {
                    'mx-2': groupDirection === 'horizontal',
                })}
            >
                <span
                    className={cx({
                        'sr-only': labelSrOnly,
                    })}
                >
                    {label}
                </span>
            </label>
        </div>
    );
};
